<div
    class="expansion-panel"
    [class.expansion-panel--shadow]="config.shadow && config.open"
    [class.expansion-panel--no-shadow]="!config.shadow"
    [class.expansion-panel--no-animations]="config.disableAnimations"
    [style.backgroundColor]="config.backgroundColor || undefined"
    (keydown.escape)="configOpenChange($event, false)"
    role="region"
>
    <div
        class="expansion-panel__header"
        [class.expansion-panel__header--start]="
            config.chevron?.align === 'start' || !config.chevron?.align
        "
        [class.expansion-panel__header--center]="config.chevron?.align === 'center'"
        [class.expansion-panel__header--end]="config.chevron?.align === 'end'"
        role="button"
        [attr.aria-expanded]="config.open"
        (keydown.enter)="configOpenChange($event, !config.open)"
        (keydown.space)="configOpenChange($event, !config.open)"
        (click)="configOpenChange($event, !config.open)"
        [attr.tabIndex]="config.tabIndex ?? 0"
    >
        <div
            class="expansion-panel__header__title"
            [class.expansion-panel__header__title--no-margin]="
                config.chevron?.vertical === true && config.open
            "
            role="header"
        >
            <ng-content select="[role=header]"></ng-content>
            @if (header) {
                {{ header }}
            }
        </div>
        @if (config.chevron?.vertical !== true || !config.open) {
            <nw-icon
                class="expansion-panel__header__chevron"
                [class.expansion-panel__header__chevron--active]="config.open"
                [class.expansion-panel__header__chevron--no-animations]="
                    config.disableAnimations
                "
                aria-hidden="true"
                focusable="false"
                [style.color]="config.chevron?.color"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill
                    viewBox="0 0 22 13"
                    height="100%"
                    width="100%"
                    style="display: block"
                    preserveAspectRatio="xMidYMid meet"
                    focusable="false"
                >
                    <path
                        fill="currentColor"
                        d="M9.94 12.06a1.502 1.502 0 0 0 2.124 0l9-9A1.502 1.502 0 0 0 18.941.935L11 8.876 3.058.942A1.502 1.502 0 0 0 .936 3.064l9 9 .005-.005Z"
                    />
                </svg>
            </nw-icon>
        }
    </div>
    <div
        class="expansion-panel__content"
        [class.expansion-panel__content--has-border]="config.open && config.hasBorder"
        [class.expansion-panel__content--open]="config.open"
        [style.height]="
            config.open
                ? config.hasBorder
                    ? 'auto'
                    : contentBody?.clientHeight + 'px'
                : '0px'
        "
        [class.expansion-panel__content--no-animations]="config.disableAnimations"
        #content
    >
        <div #contentBody (cdkObserveContent)="onContentChange()">
            <ng-content select="[role=body]"></ng-content>
            @if (body) {
                <div [innerHTML]="body | sanitizeHtml"></div>
            }
        </div>
    </div>
    @if (config.chevron?.vertical === true && config.open) {
        <nw-icon
            class="expansion-panel__chevron"
            [class.expansion-panel__chevron--active]="config.open"
            [class.expansion-panel__chevron--no-animations]="config.disableAnimations"
            aria-hidden="true"
            focusable="false"
            [style.color]="config.chevron?.color"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill
                viewBox="0 0 22 13"
                height="100%"
                width="100%"
                style="display: block"
                preserveAspectRatio="xMidYMid meet"
                focusable="false"
            >
                <path
                    fill="currentColor"
                    d="M9.94 12.06a1.502 1.502 0 0 0 2.124 0l9-9A1.502 1.502 0 0 0 18.941.935L11 8.876 3.058.942A1.502 1.502 0 0 0 .936 3.064l9 9 .005-.005Z"
                />
            </svg>
        </nw-icon>
    }
</div>
